import { Component, OnInit } from '@angular/core';
import { Observable } from "rxjs";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { process, State } from "@progress/kendo-data-query";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import { QuestionService } from '../../../core/_services/question.service';
import { TagService } from "../../../core/_services/tag.service";

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.sass']
})
export class QuestionsComponent implements OnInit {

  public view: Observable<GridDataResult>;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 10
  };

  constructor(
    private _questionService: QuestionService,
    private _router: Router,
  ) {

  }

  ngOnInit() {
    this.view = this._questionService.pipe(map(data => process(data, this.gridState)));
    this._questionService.refresh();
  }

  public onStateChange(state: State) {
    this.gridState = state;
    this._questionService.read();
  }

  public editModel({sender, rowIndex, dataItem}) {
    this._router.navigate(['/panel/question', {uuid: dataItem.uuid}]);
  }


}




